import type { EventName } from "@lit/react";
import { DateTimePicker as DateTimePickerElement, type DateTimePickerEventMap as _DateTimePickerEventMap, } from "@vaadin/date-time-picker/vaadin-date-time-picker.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DateTimePickerElement, };
export type DateTimePickerEventMap = Readonly<{
    onChange: EventName<_DateTimePickerEventMap["change"]>;
    onInvalidChanged: EventName<_DateTimePickerEventMap["invalid-changed"]>;
    onUnparsableChange: EventName<_DateTimePickerEventMap["unparsable-change"]>;
    onValidated: EventName<_DateTimePickerEventMap["validated"]>;
    onValueChanged: EventName<_DateTimePickerEventMap["value-changed"]>;
}>;
const events = { onChange: "change", onInvalidChanged: "invalid-changed", onUnparsableChange: "unparsable-change", onValidated: "validated", onValueChanged: "value-changed" } as DateTimePickerEventMap;
export type DateTimePickerProps = WebComponentProps<DateTimePickerElement, DateTimePickerEventMap>;
export const DateTimePicker = createComponent({
    elementClass: DateTimePickerElement, events, react: React, tagName: "vaadin-date-time-picker"
});
